import React from "react";
import { useNavigation } from "@react-navigation/native";
import { useTranslations } from "@src/packages/i18n";
import { useSubmitSleepActivity } from "../useSubmitSleepActivity";
import type { SleepActivityStackScreenProps } from "../SleepActivityNavigator";
import {
  BaseCompleteScreen,
  navigateToNextSection,
  getNextSectionButtonLabel,
} from "@louise/medical-history/components/BaseCompleteScreen";

export function SleepActivityCompleteScreen() {
  const t = useTranslations();
  const navigation =
    useNavigation<
      SleepActivityStackScreenProps<"SleepActivityComplete">["navigation"]
    >();
  const { submit, isPending } = useSubmitSleepActivity();

  const handleFinish = async () => {
    try {
      await submit();
      navigateToNextSection(navigation, "sleepActivity");
    } catch {}
  };

  return (
    <BaseCompleteScreen
      title={t("med_history.lifestyle.sleep_activity.complete_title")}
      subtitle={t("med_history.lifestyle.sleep_activity.complete_subtitle")}
      secondarySubtitle={null}
      buttonLabel={getNextSectionButtonLabel(t, "sleepActivity")}
      isSubmitting={isPending}
      onFinish={handleFinish}
    />
  );
}
